import React, { useEffect, useState } from 'react';
import { IonInput, IonItem } from '@ionic/react';

// Components
import { ValidatorMessageComponent } from '../../components';
import { formatNumber } from '../../helpers';
import { useCurrencyInput } from '../../hooks/useCurrencyInput';

export const AmountComponent = ({
    amount,
    handleInputChange,
    handleKeyUp,
    inputs,
    validation,
    pageConfig
}) => {
    const { displayValue, onChange } = useCurrencyInput(amount, handleInputChange);

    return (
        <>
            <h3 className="title-price">IMPORTE SIN DESCUENTO</h3>
            <IonItem>
                <div className="price">
                    <p>$</p>
                    <IonInput
                        id='amount-input'
                        name='amount'
                        type="text"
                        value={displayValue}
                        placeholder="0"
                        onIonChange={onChange}
                        onKeyUp={handleKeyUp}
                    >
                    </IonInput>
                </div>
            </IonItem>
            {
                validation.summary?.map((v, index) => {

                    return v.key === inputs.amount &&
                        <ValidatorMessageComponent key={index} message={v.message} />
                })
            }
        </>
    )
}
